import { useApi } from "@akina/infra";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "./query";

export const useFetchFirstSessionExercises = (treatmentTemplateKey: string | undefined) => {
  const { api } = useApi();

  return useQuery({
    queryKey: [QueryKeys.fetchFirstSessionExercises, treatmentTemplateKey],
    queryFn: () =>
      treatmentTemplateKey ? api.template.getFirstSessionExercises(treatmentTemplateKey) : Promise.resolve(null),
    enabled: !!treatmentTemplateKey,
  });
};
